/* MXM chat UI 20260915-actual-host-v1. Verified target: shopify-chat / part=activator. */
(function () {
  'use strict';
  if (window.mxmChatUI && window.mxmChatUI.destroy) window.mxmChatUI.destroy();

  var VERSION = '20260915-actual-host-v1';
  var STYLE_ID = 'mxm-chat-actual-host-style';
  var states = new Map();
  var timers = [];
  var raf = 0;
  var stopped = false;
  var bodyObserver;
  var cookieObserver;
  var cookieResize;
  var currentCookie;

  /* Internal overrides also neutralise the transformed nudge ancestor.
     The conversation panel, its contents and its handlers are not replaced. */
  var SHADOW_CSS = [
    ':host([data-mxm-chat-ui]) { transform:none!important; translate:none!important; rotate:none!important; scale:none!important; filter:none!important; perspective:none!important; contain:none!important; will-change:auto!important; }',
    ':host([data-mxm-chat-ui]) #shopify-element-wrapper { transform:none!important; translate:none!important; rotate:none!important; scale:none!important; filter:none!important; perspective:none!important; contain:none!important; will-change:auto!important; }',
    ':host([data-mxm-chat-ui]) .activator-nudge { position:fixed!important; inset:auto var(--mxm-chat-right,16px) var(--mxm-chat-bottom,16px) auto!important; margin:0!important; transform:none!important; translate:none!important; rotate:none!important; scale:none!important; filter:none!important; perspective:none!important; contain:none!important; will-change:auto!important; }',
    ':host([data-mxm-chat-ui]) button[part~="activator"] { position:fixed!important; inset:auto var(--mxm-chat-right,16px) var(--mxm-chat-bottom,16px) auto!important; margin:0!important; height:var(--mxm-chat-height,44px)!important; min-height:var(--mxm-chat-height,44px)!important; box-sizing:border-box!important; transform:none!important; translate:none!important; rotate:none!important; scale:none!important; transition-property:background-color,color,box-shadow!important; animation:none!important; }',
    '@media(max-width:1023px) { :host([data-mxm-product-page="true"]), :host([data-mxm-product-page="true"]) #shopify-element-wrapper, :host([data-mxm-product-page="true"]) button[part~="activator"] { display:none!important; visibility:hidden!important; pointer-events:none!important; } }'
  ].join('\n');

  function setAttribute(el, key, value) {
    if (el.getAttribute(key) !== value) el.setAttribute(key, value);
  }
  function setVar(el, key, value) {
    if (el.style.getPropertyValue(key) !== value) el.style.setProperty(key, value);
  }
  function isProduct() {
    return document.body.classList.contains('template-product') || /\/products\//.test(window.location.pathname);
  }
  function watchCookie(cookie) {
    if (cookie === currentCookie) return;
    if (cookieObserver) cookieObserver.disconnect();
    if (cookieResize) cookieResize.disconnect();
    currentCookie = cookie;
    if (!cookie) return;
    cookieObserver = new MutationObserver(schedule);
    cookieObserver.observe(cookie, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    if (window.ResizeObserver) {
      cookieResize = new ResizeObserver(schedule);
      cookieResize.observe(cookie);
    }
  }
  function attach(host) {
    var root = host.shadowRoot;
    if (!root) return;
    var previous = states.get(host);
    if (!previous || previous.root !== root) {
      if (previous) previous.observer.disconnect();
      var observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-expanded', 'hidden'] });
      states.set(host, { root: root, observer: observer });
    }
    if (!root.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = SHADOW_CSS;
      root.appendChild(style);
    }
  }
  function sync() {
    if (stopped || !document.body) return;
    var obsolete = document.getElementById('mxmChatButton');
    if (obsolete) obsolete.remove();
    var cookie = document.getElementById('cookiePreferencesBtn');
    watchCookie(cookie);
    var bottom = 16;
    var height = 44;
    if (cookie) {
      var rect = cookie.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        bottom = Math.max(0, window.innerHeight - rect.bottom);
        height = rect.height;
      }
    }
    var product = isProduct() ? 'true' : 'false';
    document.querySelectorAll('shopify-chat').forEach(function (host) {
      setAttribute(host, 'data-mxm-chat-ui', VERSION);
      setAttribute(host, 'data-mxm-product-page', product);
      setVar(host, '--mxm-chat-bottom', bottom + 'px');
      setVar(host, '--mxm-chat-height', height + 'px');
      setVar(host, '--mxm-chat-right', '16px');
      attach(host);
    });
    states.forEach(function (state, host) {
      if (!host.isConnected) {
        state.observer.disconnect();
        states.delete(host);
      }
    });
  }
  function schedule() {
    if (raf || stopped) return;
    raf = window.requestAnimationFrame(function () { raf = 0; sync(); });
  }
  function init() {
    if (stopped) return;
    sync();
    bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    [100, 300, 750, 1500, 3000, 6000, 12000].forEach(function (delay) {
      timers.push(window.setTimeout(schedule, delay));
    });
    if (window.customElements) window.customElements.whenDefined('shopify-chat').then(schedule);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }
    if (document.fonts) document.fonts.ready.then(schedule);
  }
  window.mxmChatUI = {
    version: VERSION,
    refresh: schedule,
    destroy: function () {
      stopped = true;
      if (raf) window.cancelAnimationFrame(raf);
      timers.forEach(window.clearTimeout);
      if (bodyObserver) bodyObserver.disconnect();
      if (cookieObserver) cookieObserver.disconnect();
      if (cookieResize) cookieResize.disconnect();
      states.forEach(function (state) { state.observer.disconnect(); });
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('pageshow', schedule);
      document.removeEventListener('shopify:section:load', schedule);
      document.removeEventListener('DOMContentLoaded', init);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', schedule);
        window.visualViewport.removeEventListener('scroll', schedule);
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
